export default {
  back: 'Voltar ao Menu',
  menu: 'Menu',
};
